import React from 'react'

import { useChecklist } from './_load/ChecklistLoader'
import DynamicForm from '../../../containers/dynamic/form/DynamicForm'

const ChecklistPreview = () => {
  const { questions } = useChecklist() || {}

  return <DynamicForm questions={questions} replies={[]} />
}

export default ChecklistPreview
